import { toast } from "react-toastify";
import fetcher from "../../lib/fetcher";
import useSWRMutation from "swr/mutation";

const useChangeNumberPhone = () => {
  async function changeNumberPhone(
    url: string,
    { arg }: { arg: { phone: string; otp: string } }
  ) {
    try {
      const data = await fetcher.swr(url, {
        method: "PATCH",
        data: { phone: arg.phone, otp: arg.otp },
      });

      return data.result;
    } catch (error: any) {
      toast.error(`Что-то не так. Проверьте номер. Причина: ${error}`);
      throw new Error(error);
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    "/auth/change-phone",
    changeNumberPhone
  );

  return { data: data, error, isMutating, trigger };
};
export default useChangeNumberPhone;
